import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { Toaster } from 'sonner';

import '@/App.css';
import Navbar from '@/components/dubinko/Navbar';
import Footer from '@/components/dubinko/Footer';
import MascotChat from '@/components/dubinko/MascotChat';
import FloatingContacts from '@/components/dubinko/FloatingContacts';
import InstallPrompt from '@/components/dubinko/InstallPrompt';
import StickyCTA from '@/components/dubinko/StickyCTA';
import ExitIntentPopup from '@/components/dubinko/ExitIntentPopup';
import ProtectedRoute from '@/components/dubinko/ProtectedRoute';
import AnalyticsTracker from '@/components/dubinko/AnalyticsTracker';
import { AuthProvider } from '@/contexts/AuthContext';

import HomePage from '@/pages/HomePage';
import ServicesPage from '@/pages/ServicesPage';
import BookingPage from '@/pages/BookingPage';
import AboutPage from '@/pages/AboutPage';
import ContactPage from '@/pages/ContactPage';
import LoginPage from '@/pages/LoginPage';
import RegisterPage from '@/pages/RegisterPage';
import CustomerDashboard from '@/pages/CustomerDashboard';
import AdminPage from '@/pages/AdminPage';
import ReviewsPage from '@/pages/ReviewsPage';
import AreasIndexPage from '@/pages/AreasIndexPage';
import ServiceAreaPage from '@/pages/ServiceAreaPage';
import SavetiPage from '@/pages/SavetiPage';
import BlogPostPage from '@/pages/BlogPostPage';

export default function App() {
  return (
    <div className="App min-h-screen bg-white text-slate-900">
      <HelmetProvider>
        <AuthProvider>
          <BrowserRouter>
            <AnalyticsTracker />
            <Navbar />
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/usluge" element={<ServicesPage />} />
              <Route path="/rezervacija" element={<BookingPage />} />
              <Route path="/o-nama" element={<AboutPage />} />
              <Route path="/kontakt" element={<ContactPage />} />
              <Route path="/recenzije" element={<ReviewsPage />} />
              <Route path="/podrucja" element={<AreasIndexPage />} />
              <Route path="/podrucja/:slug" element={<ServiceAreaPage />} />
              <Route path="/saveti" element={<SavetiPage />} />
              <Route path="/saveti/:slug" element={<BlogPostPage />} />
              <Route path="/prijava" element={<LoginPage />} />
              <Route path="/registracija" element={<RegisterPage />} />
              <Route path="/nalog" element={<ProtectedRoute><CustomerDashboard /></ProtectedRoute>} />
              <Route path="/admin" element={<ProtectedRoute role="admin"><AdminPage /></ProtectedRoute>} />
              <Route path="*" element={<HomePage />} />
            </Routes>
            <Footer />
            <MascotChat />
            <FloatingContacts />
            <InstallPrompt />
            <StickyCTA />
            <ExitIntentPopup />
            <Toaster richColors position="top-right" />
          </BrowserRouter>
        </AuthProvider>
      </HelmetProvider>
    </div>
  );
}
